<template>
  <div class="header">
    <div class="container-fluid">
      <!-- Hearer  -->
      <div class="mt-4">
        <div class="card">
          <div class="card-body">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item fw-bolder">Master Data</li>
                <li class="breadcrumb-item">Internal Memo</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <!-- Card  -->
      <div class="card mt-5">
        <div class="card-header">
          <!-- Title -->
          <h4 class="card-header-title">Internal Memo</h4>
          <b-dropdown id="dropdown-1" left text="Create Internal Memo" variant="primary" class="mr-0 ml-0 mt-0 mb-0 pr-0 pl-0">
            <b-dropdown-item @click="showModalFormBRS()">BRS</b-dropdown-item>
            <b-dropdown-item @click="showModalFormPK()">Pengajuan Khusus</b-dropdown-item>
          </b-dropdown>
        </div>
        <!-- <button
                  class="btn btn-outline-primary mr-2 mb-2 mb-lg-0"
                  @click="showModalFormBRS()"
              >
                Create BRS
              </button>
              <br />
              <button
                  class="btn btn-outline-primary mr-2 mb-2 mb-lg-0"
                  @click="showModalFormPK()"
              >
                Create Pengajuan Khusus
              </button> -->

        <div class="card-body">
          <label><strong>Filter</strong></label>
          <div class="row row-cols-1 row-cols-md-2 row-cols-xl-3">
            <div class="form-group col">
              <label>Year</label>
              <v-select
                :options="listYear"
                label="im_year"
                :reduce="(e) => e.im_year"
                v-model="body.im_year"
                placeholder="Select/Type Here..."
                class="w-md-auto"
              />
            </div>
            <div class="form-group col">
              <label>Category</label>
              <v-select
                :options="imCategoriesList"
                :reduce="(e) => e.value"
                v-model="body.im_category"
                placeholder="Select/Type Here..."
                class="w-md-auto"
              />
            </div>
            <div class="form-group col">
              <label>Department</label>
              <v-select
                :options="listDepartment"
                :reduce="(e) => e.value"
                v-model="body.im_department"
                placeholder="Select/Type Here..."
                class="w-md-auto"
                multiple
              />
            </div>

            <div class="form-group col">
              <label class="d-block">Created At</label>
              <date-picker
                v-model="body.created_at"
                range
                value-format="YYYY-MM-DD"
                format="YYYY-MM-DD"
                value-type="format"
                :clearable="true"
              ></date-picker>
            </div>
            <div class="form-group col">
              <label class="d-block">Updated At</label>
              <date-picker
                v-model="body.updated_at"
                range
                value-format="YYYY-MM-DD"
                format="YYYY-MM-DD"
                value-type="format"
                :clearable="true"
              ></date-picker>
            </div>
            <div class="form-group col">
              <label>
                Search
                <span v-b-popover.hover.right="'Search by internal memo name and internal memo number'" variant="secondary" style="cursor: pointer">
                  <i class="fe fe-help-circle text-danger" style="cursor: help"></i>
                </span>
              </label>
              <b-form-input v-model="body.search" placeholder="Type Internal Memo..." @keyup.enter="getList()"></b-form-input>
            </div>
            <div class="form-group col">
              <label> Status </label>
              <v-select
                :options="imStatusOption"
                :reduce="(e) => e.value"
                v-model="body.status_actual"
                placeholder="Select/Type Here..."
                class="w-md-auto"
              />
            </div>
          </div>
          <div class="row row-cols-1 row-cols-md-2 gy-3">
            <div class="col">
              <div class="w-25">
                <label>Border Info:</label>
                <div class="row gy-2 gx-0 w-30">
                  <div class="col-12">
                    <div
                      class="bg-success text-center"
                      style="height: 20px; width: 100%; cursor: pointer"
                      v-b-popover.hover.right="'IM value habis digunakan sesuai dengan batas valuenya'"
                    >
                      Fulfilled
                    </div>
                  </div>
                  <div class="col-12">
                    <div
                      class="bg-warning text-center"
                      style="height: 20px; width: 100%; cursor: pointer"
                      v-b-popover.hover.right="'IM value belum habis digunakan melalui pembuatan PO'"
                    >
                      Underutilized
                    </div>
                  </div>
                  <div class="col-12">
                    <div
                      class="bg-danger text-center text-white"
                      style="height: 20px; width: 100%; cursor: pointer"
                      v-b-popover.hover.right="'IM value sudah digunakan melebihi batas valuenya melalui pembuatan PO'"
                    >
                      IM Value Exceed
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col d-flex justify-content-end align-items-end">
              <div>
                <b-button class="btn mr-1" variant="primary" @click="resetForm()"> Reset </b-button>
                <b-button class="btn" variant="primary" @click="getList()"> Filter </b-button>
              </div>
            </div>
          </div>
        </div>

        <div style="overflow-x: auto">
          <vue-good-table
            :line-numbers="true"
            :columns="columnsTable"
            :rows="list.data"
            :total-rows="list.totalItems"
            :pagination-options="{
              enabled: true,
              perPage: body.perPage,
            }"
            @on-page-change="onPageChange"
            @on-per-page-change="onPageChange"
            @on-sort-change="onSortChange"
            style-class="vgt-table border-0 table"
            :row-style-class="getRowClass"
          >
            <!-- Loading -->
            <div slot="emptystate" class="text-center font-size-14">No data available</div>
            <!-- Custom Action Buttons -->
            <template #table-row="props">
              <span
                v-if="
                  props.column.field === 'im_number' ||
                  props.column.field === 'name' ||
                  props.column.field === 'im_category' ||
                  props.column.field === 'updated_at'
                "
                @click="showModalDetail(props.row)"
              >
                {{ props.formattedRow[props.column.field] }}
              </span>
              <span v-else-if="props.column.field === 'im_year'" @click="showModalDetail(props.row)">
                <span v-if="props.row.im_year > 0">
                  {{ props.row.im_year }}
                </span>
                <span v-else></span>
              </span>
              <span v-else-if="props.column.field === 'attachments'">
                <template v-if="props.row.attachments.length">
                  <b-button
                    style="width: 300px"
                    block
                    type="button"
                    variant="outline-primary"
                    class="d-flex justify-content-between align-items-center"
                    v-b-toggle="props.index + '_files'"
                  >
                    <span>{{ props.row.attachments.length }} Files</span>
                    <span>
                      <span v-if="openCollapse === props.index" class="fe fe-chevron-up"></span>
                      <span v-else class="fe fe-chevron-down"></span>
                    </span>
                  </b-button>
                  <b-collapse
                    style="width: 300px"
                    :accordion="`${props.row.attachments.length} Files`"
                    :id="props.index + '_files'"
                    @shown="openCollapse = props.index"
                    @hidden="openCollapse = null"
                  >
                    <ul>
                      <li v-for="(attachment, index) in props.row.attachments">
                        <a style="margin: 0" :href="attachment.url" target="_blank">
                          {{ attachment.filename }}
                        </a>
                        <!-- <span v-if="index < props.row.attachments.length - 1">, </span> -->
                      </li>
                    </ul>
                  </b-collapse>
                </template>
                <span v-else>-</span>
              </span>
              <span v-else-if="props.column.field === 'departments'">
                <template v-if="props.row.departments.length">
                  <b-button
                    style="width: 300px"
                    block
                    type="button"
                    variant="outline-primary"
                    class="d-flex justify-content-between align-items-center"
                    v-b-toggle="props.index + '_departments'"
                  >
                    <span>{{ props.row.departments.length }} Departments</span>
                    <span>
                      <span v-if="openCollapse === props.index" class="fe fe-chevron-up"></span>
                      <span v-else class="fe fe-chevron-down"></span>
                    </span>
                  </b-button>
                  <b-collapse
                    style="width: 300px"
                    :accordion="`${props.row.departments.length} Departments`"
                    :id="props.index + '_departments'"
                    @shown="openCollapse = props.index"
                    @hidden="openCollapse = null"
                  >
                    <ul>
                      <li v-for="(department, index) in props.row.departments">
                        {{ `${department.department_code} - ${department.department_name}` }}
                      </li>
                    </ul>
                  </b-collapse>
                </template>
                <span v-else>-</span>
              </span>
              <span v-else-if="props.column.field === 'actions'">
                <b-dropdown id="dropdown-dropleft" dropleft variant="primary" class="m-2">
                  <b-dropdown-item v-if="isUpdate" class="hovering" @click="updateData(props.row)"> Edit </b-dropdown-item>
                  <b-dropdown-item
                    v-if="isDelete && props.row.budget_relocate?.length == 0 && props.row.budget_actual?.length == 0"
                    class="hovering"
                    @click="deleteData(props.row.id)"
                  >
                    Delete
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-else-if="isDelete"
                    class="hovering"
                    v-b-popover.hover.left="
                      ` ${
                        props.row.budget_relocate?.length > 0
                          ? 'IM BRS ini tidak dapat dihapus karena sudah ada relokasi yang  menggunakan sebagai referensi, IM BRS hanya akan bisa dihapus jika data BRS dihapus terlebih dahulu'
                          : `IM PK tidak bisa dihapus, karena sudah digunakan oleh beberapa PR/PO, silahkan menghapus referensi PR/PO terhadap IM PK ini agar dapat menghapus Internal Memo ini`
                      }`
                    "
                    variant="secondary"
                    style="cursor: pointer"
                  >
                    <span class="text-secondary">Delete</span>
                  </b-dropdown-item>
                </b-dropdown>
              </span>
              <b-tooltip :target="'tooltip-delete-' + props.row.id" placement="left">
                Cannot delete because it has been used in budget relocate or actual
              </b-tooltip>
            </template>
            <template slot="pagination-bottom" slot-scope="props">
              <div class="d-flex justify-content-end">
                <div>
                  <b-pagination
                    :value="1"
                    :total-rows="list.totalItems"
                    :per-page="body.pageSize"
                    first-number
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mr-3 mb-4 mt-0"
                    @input="(value) => props.pageChanged({ currentPage: value })"
                  >
                  </b-pagination>
                </div>
              </div>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
    <b-modal size="lg" id="modal-1" hide-footer title="Internal Memo Form" @hide="resetModal()">
      <form @submit.prevent="saveAdd()" v-if="isAdd === true">
        <!-- IM Category (Select Dropdown) -->
        <div class="form-group">
          <label>Category <span class="text-danger">*</span></label>
          <select class="form-control" v-model="modalCreate.im_category" name="Category" v-validate="'required'">
            <option value="" disabled>Select Category</option>
            <option v-for="category in imCategories" :key="category" :value="category">{{ category }}</option>
          </select>
          <span class="text-sm text-danger" v-show="errors.has('Category')">{{ errors.first('Category') }}</span>
        </div>

        <div class="form-group">
          <label>Number <span class="text-danger">*</span></label>
          <input type="text" class="form-control" v-model="modalCreate.im_number" name="Number" v-validate="'required|max:200'" />
          <span class="text-sm text-danger" v-show="errors.has('Number')">{{ errors.first('Number') }}</span>
        </div>

        <!-- IM Year -->
        <div class="form-group row">
          <div class="col-12">
            <label>Year <span class="text-danger">*</span></label>
          </div>
          <div class="col-12">
            <date-picker
              v-model="modalCreate.im_year"
              type="year"
              format="YYYY"
              value-type="format"
              name="IM Year"
              v-validate="'required'"
              class="w-100"
            />
            <!-- :disabled-date="disableFutureYears" -->
            <span class="text-sm text-danger" v-show="errors.has('Year')">
              {{ errors.first('Year') }}
            </span>
          </div>
        </div>
        <!-- IM Year -->
        <div class="form-group row">
          <div class="col-12">
            <label>Year <span class="text-danger">*</span></label>
          </div>
          <div class="col-12">
            <date-picker
              v-model="modalCreate.im_year"
              type="year"
              format="YYYY"
              value-type="format"
              name="IM Year"
              v-validate="'required'"
              class="w-100"
            />
            <!-- :disabled-date="disableFutureYears" -->
            <span class="text-sm text-danger" v-show="errors.has('Year')">
              {{ errors.first('Year') }}
            </span>
          </div>
        </div>

        <!-- IM Title -->
        <div class="form-group">
          <label>Title <span class="text-danger">*</span></label>
          <input type="text" class="form-control" v-model="modalCreate.name" name="Title" v-validate="'required|max:1000'" />
          <span class="text-sm text-danger" v-show="errors.has('Title')">{{ errors.first('Title') }}</span>
        </div>

        <!-- Action Buttons -->
        <div class="card">
          <div class="card-header">Imternal Memo Files</div>
          <div class="card-body">
            <div class="form-group">
              <label>Upload (DOCX/PDF) (max size: 10MB) <span class="text-danger">*</span></label>
              <input
                type="file"
                class="form-control"
                v-validate="'required'"
                ref="fileUpload"
                name="File"
                accept=".pdf,.docx"
                multiple
                @change="fileUploader($event, 'create')"
              />
              <span class="text-sm text-danger" v-show="errors.has('File')">
                {{ errors.first('File') }}
              </span>
              <span class="text-sm text-danger" v-if="fileError">
                {{ fileError }}
              </span>
              <!-- Display the list of selected files -->
              <div v-if="modalCreate.file && modalCreate.file.length">
                <p>Selected Files:</p>
                <ul>
                  <li v-for="(file, index) in modalCreate.file" :key="index">
                    {{ file.name }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-11">Internal Memo Values</div>
              <div class="col-1 align-items-end">
                <button type="button" class="btn btn-sm btn-success pt-1" @click="newMemoItems()">Add</button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <!--                  <div class="text-right">
                    <button type="button" class="btn btn-sm btn-success mb-2" @click="newMemoItems()">Add</button>
                  </div>-->
            <div class="card" v-for="(item, index) in memoItems" :key="`memoItems_${index}`">
              <div class="card-body">
                <div class="card-btn-remove">
                  <i class="fe fe-x-circle text-danger" style="cursor: pointer" @click="removeProject(index)" />
                </div>
                <div class="row">
                  <div class="form-group col-3">
                    <label>GL Type</label>
                    <v-select
                      v-model="item.type"
                      :options="optionsGLType"
                      :reduce="(e) => e.value"
                      placeholder="Select Type"
                      v-validate="'required'"
                      @input="selectType(index)"
                      :name="`type_${index}`"
                    />
                    <span class="text-danger" v-show="isDuplicateErrorType(index)"> Type is Duplicate </span>
                    <span class="text-sm text-danger" v-show="errors.has(`type_${index}`)"> Type is Required </span>
                  </div>
                  <div class="form-group col-5">
                    <label>Project</label>
                    <input
                      class="form-control"
                      type="text"
                      v-model="item.project_name"
                      :name="`${index}_project_name`"
                      v-validate="'required'"
                      @blur="selectType(index)"
                    />
                    <span class="text-danger" v-show="isDuplicateErrorType(index)"> Project is Duplicate </span>
                    <span class="text-sm text-danger" v-show="errors.has(`type_${index}`)"> Project is Required </span>
                  </div>
                  <div class="form-group col-4">
                    <label>Relocation Value</label>
                    <vue-numeric class="form-control" currency="Rp. " separator="," v-model="item.relocate_value" @blur="countSum()" />
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-6">
                    <label>Used Value</label>
                    <input class="form-control" type="text" disabled />
                  </div>
                  <div class="form-group col-6">
                    <label>Remaining Value</label>
                    <input class="form-control" type="text" disabled />
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-6">
                    <label>Relocation Status</label>
                    <input class="form-control" type="text" disabled />
                  </div>
                  <div class="form-group col-6">
                    <label>Fullfilled Status</label>
                    <input class="form-control" type="text" disabled />
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="form-group col-12">
                    <label>Total Used IM Value</label>
                    <vue-numeric class="form-control" currency="Rp. " separator="," v-model="sumImUsedValue" disabled />
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12">
                    <label>Total Remaining IM Value</label>
                    <vue-numeric class="form-control" currency="Rp. " separator="," v-model="sumImRemainingValue" disabled />
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12">
                    <label>Total IM Value</label>
                    <vue-numeric class="form-control" currency="Rp. " separator="," v-model="sumImValue" disabled />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4 d-flex justify-content-end">
          <button
            class="mr-2 mt-4 btn btn-outline-primary"
            @click="
              $bvModal.hide('modal-1');
              resetModal();
            "
            type="button"
          >
            Cancel
          </button>
          <button class="mt-4 btn btn-primary" type="submit" v-if="isLoading == false">Save</button>
          <button class="mt-4 btn btn-primary" type="button" disabled v-else>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Loading...
          </button>
        </div>
      </form>

      <form @submit.prevent="saveUpdate()" v-else>
        <!-- IM Category (Select Dropdown) -->
        <div class="form-group">
          <label>Category <span class="text-danger">*</span></label>
          <select class="form-control" v-model="modalUpdate.im_category" name="Category" v-validate="'required'">
            <option value="" disabled>Select Category</option>
            <option v-for="category in imCategories" :key="category" :value="category">{{ category }}</option>
          </select>
          <span class="text-sm text-danger" v-show="errors.has('IM Category')">{{ errors.first('Category') }}</span>
        </div>

        <div class="form-group">
          <label>Number <span class="text-danger">*</span></label>
          <input type="text" class="form-control" v-model="modalUpdate.im_number" name="Number" v-validate="'required|max:200'" />
          <span class="text-sm text-danger" v-show="errors.has('Number')">{{ errors.first('Number') }}</span>
        </div>

        <!-- IM Year -->
        <div class="form-group row">
          <div class="col-12">
            <label>Year <span class="text-danger">*</span></label>
          </div>
          <div class="col-12">
            <date-picker
              v-model="modalUpdate.im_year"
              type="year"
              format="YYYY"
              value-type="format"
              name="IM Year"
              v-validate="'required'"
              class="w-100"
            />
            <!-- :disabled-date="disableFutureYears" -->
            <span class="text-sm text-danger" v-show="errors.has('Year')">
              {{ errors.first('Year') }}
            </span>
          </div>
        </div>
        <!-- IM Year -->
        <div class="form-group row">
          <div class="col-12">
            <label>Year <span class="text-danger">*</span></label>
          </div>
          <div class="col-12">
            <date-picker
              v-model="modalUpdate.im_year"
              type="year"
              format="YYYY"
              value-type="format"
              name="IM Year"
              v-validate="'required'"
              class="w-100"
            />
            <!-- :disabled-date="disableFutureYears" -->
            <span class="text-sm text-danger" v-show="errors.has('Year')">
              {{ errors.first('Year') }}
            </span>
          </div>
        </div>

        <!-- IM Title -->
        <div class="form-group">
          <label>Title <span class="text-danger">*</span></label>
          <input type="text" class="form-control" v-model="modalUpdate.name" name="Title" v-validate="'required|max:1000'" />
          <span class="text-sm text-danger" v-show="errors.has('Title')">{{ errors.first('Title') }}</span>
        </div>

        <!-- Action Buttons -->
        <div class="card">
          <div class="card-header">Imternal Memo Files</div>
          <div class="card-body">
            <div class="card" v-if="modalUpdate.exist_file?.length">
              <div class="card-body">
                <span>Current File: </span>
                <div v-for="(attachment, index) in modalUpdate.exist_file" :key="index">
                  <a :href="attachment.url" target="_blank">
                    {{ attachment.filename }}
                  </a>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <label>File (DOCX/PDF)</label>
                <input
                  type="file"
                  class="form-control"
                  ref="fileUpload"
                  name="File"
                  accept=".pdf,.docx"
                  multiple
                  @change="fileUploader($event, 'update')"
                />
                <span class="text-sm text-danger" v-show="errors.has('File')">{{ errors.first('File') }}</span>
                <span class="text-sm text-danger" v-if="fileError">
                  {{ fileError }}
                </span>
                <!-- Display the list of selected files -->
                <div v-if="modalUpdate.file && modalUpdate.file.length">
                  <p>Selected Files:</p>
                  <ul>
                    <li v-for="(file, index) in modalUpdate.file" :key="index">
                      {{ file.name }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-11">Internal Memo Values</div>
              <div class="col-1 align-items-end">
                <button type="button" class="btn btn-sm btn-success pt-1" @click="newMemoItemsUpdate()">Add</button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="card" v-for="(item, index) in this.modalUpdate.im_projects" :key="`memoItems_${index}`">
              <div class="card-body">
                <div class="card-btn-remove">
                  <i class="fe fe-x-circle text-danger" style="cursor: pointer" @click="removeProjectUpdate(index)" />
                </div>
                <div class="row">
                  <div class="form-group col-3">
                    <label>GL Type</label>
                    <v-select
                      v-model="item.type"
                      :options="optionsGLType"
                      :reduce="(e) => e.value"
                      placeholder="Select Type"
                      v-validate="'required'"
                      @input="selectType(index)"
                      :name="`type_${index}`"
                    />
                    <span class="text-danger" v-show="isDuplicateErrorType(index)"> Type is Duplicate </span>
                    <span class="text-sm text-danger" v-show="errors.has(`type_${index}`)"> Type is Required </span>
                  </div>
                  <div class="form-group col-5">
                    <label>Project</label>
                    <input
                      class="form-control"
                      type="text"
                      v-model="item.project_name"
                      :name="`${index}_project_name`"
                      v-validate="'required'"
                      @blur="selectTypeUpdate(index)"
                    />
                    <span class="text-danger" v-show="isDuplicateErrorTypeUpdate(index)"> Project is Duplicate </span>
                    <span class="text-sm text-danger" v-show="errors.has(`type_Update_${index}`)"> Project is Required </span>
                  </div>
                  <div class="form-group col-4">
                    <label>Relocation Value</label>
                    <vue-numeric class="form-control" currency="Rp. " separator="," v-model="item.relocate_value" @blur="countSumUpdate()" />
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-6">
                    <label>Used Value</label>
                    <input class="form-control" type="text" disabled />
                  </div>
                  <div class="form-group col-6">
                    <label>Remaining Value</label>
                    <input class="form-control" type="text" disabled />
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-6">
                    <label>Relocation Status</label>
                    <input class="form-control" type="text" disabled />
                  </div>
                  <div class="form-group col-6">
                    <label>Fullfilled Status</label>
                    <input class="form-control" type="text" disabled />
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="form-group col-12">
                    <label>Total Used IM Value</label>
                    <vue-numeric class="form-control" currency="Rp. " separator="," v-model="sumImUsedValue" disabled />
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12">
                    <label>Total Remaining IM Value</label>
                    <vue-numeric class="form-control" currency="Rp. " separator="," v-model="sumImRemainingValue" disabled />
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12">
                    <label>Total IM Value</label>
                    <vue-numeric class="form-control" currency="Rp. " separator="," v-model="sumImValue" disabled />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-4 d-flex justify-content-end">
          <button
            class="mr-2 mt-4 btn btn-outline-primary"
            @click="
              $bvModal.hide('modal-1');
              resetModal();
            "
            type="button"
          >
            Cancel
          </button>
          <button class="mt-4 btn btn-primary" type="submit" v-if="isLoading == false">Update</button>
          <button class="mt-4 btn btn-primary" type="button" disabled v-else>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Loading...
          </button>
        </div>
      </form>
    </b-modal>
    <ModalFormBRS
      id="modal-BRS"
      @show-modal="showModalFormBRS"
      @hide-modal="hideModalFormBRS"
      @get-list-im="getList"
      @get-list-year="getListBoxYear"
      @get-list-department="getListAllDepartments"
      ref="modalFormBRS"
      :rowId="rowId"
    />
    <ModalFormPK
      id="modal-PK"
      @show-modal="showModalFormPK"
      @hide-modal="hideModalFormPK"
      @get-list-im="getList"
      @get-list-year="getListBoxYear"
      @get-list-department="getListAllDepartments"
      ref="modalFormPK"
      :rowId="rowId"
    />
    <ModalDetailBRS :id="idDetail" />
    <ModalDetailPK :id="idDetail" />
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import axiosIns from '@/api/axios';
import ModalFormBRS from '@/views/masterData/im/components/ModalFormBRS.vue';
import ModalFormPK from '@/views/masterData/im/components/ModalFormPK.vue';
import ModalDetailBRS from './im/components/modalDetailBRS.vue';
import ModalDetailPK from './im/components/modalDetailPK.vue';

export default {
  name: 'im-number',
  components: {
    ModalFormBRS,
    ModalFormPK,
    ModalDetailBRS,
    ModalDetailPK,
  },
  computed: {
    list() {
      return this.$store.getters['imNumber/listData'];
    },
    listYear() {
      return this.$store.getters['imNumber/listYear'];
    },
    listDepartment() {
      return this.$store.getters['imNumber/listDepartment']
        .sort((a, b) => a.department_code.localeCompare(b.department_code)) // ASC sort
        .map((items) => ({
          label: `${items.department_code} - ${items.department_name}`,
          value: items.id,
          row: items,
        }));
    },
  },
  data() {
    return {
      duplicateErrorIndexesType: [],
      duplicateErrorIndexesTypeUpdate: [],
      optionsGLType: [
        { value: 'opex', label: 'Opex' },
        { value: 'capex', label: 'Capex' },
      ],
      sumImValue: 0,
      sumImRemainingValue: 0,
      sumImUsedValue: 0,
      memoItems: [],
      openCollapse: null,
      body: {
        pageNumber: 1,
        pageSize: 10,
        search: '',
        status_actual: '',
        field: '',
        order: '',
        im_category: '',
        im_year: '',
        im_department: '',
        created_at: [],
        updated_at: [],
      },
      modalCreate: {
        im_number: '',
        name: '',
        im_category: '',
        im_year: '',
        file: [],
      },
      modalUpdate: {
        im_number: '',
        name: '',
        im_category: '',
        im_year: '',
        exist_file: '',
        file: [],
        im_projects: [],
      },
      id: '',
      isAdd: true,
      isLoading: false,
      searchTerm: '',
      fileError: '',
      columnsTable: [
        {
          label: 'Category',
          field: 'im_category',
          sortable: false,
          thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
          tdClass: 'no-wrap color-secondary align-middle wrap-text',
        },
        {
          label: 'Number',
          field: 'im_number',
          sortable: false,
          thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
          tdClass: 'no-wrap color-secondary align-middle wrap-text',
        },
        {
          label: 'Year',
          field: 'im_year',
          sortable: true,
          thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
          tdClass: 'no-wrap color-secondary align-middle wrap-text',
        },
        {
          label: 'Name',
          field: 'name',
          sortable: false,
          thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
          tdClass: 'no-wrap color-secondary align-middle wrap-text',
        },
        {
          label: 'Departments',
          field: 'departments',
          sortable: false,
          thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
          tdClass: 'no-wrap color-secondary align-middle wrap-text',
        },
        {
          label: 'File',
          field: 'attachments',
          sortable: false,
          thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
          tdClass: 'no-wrap color-secondary align-middle wrap-text',
        },
        {
          label: 'Action',
          field: 'actions',
          sortable: false,
          thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
          tdClass: 'no-wrap color-secondary align-middle',
        },
      ],
      imCategories: ['Pengajuan Khusus', 'Budget Relocation Statement (BRS)'],
      imCategoriesList: [
        { value: 'Pengajuan Khusus', label: 'Pengajuan Khusus' },
        { value: 'Budget Relocation Statement (BRS)', label: 'Budget Relocation Statement (BRS)' },
      ],
      imStatusOption: [
        { value: 'underutilized', label: 'Underutilized' },
        { value: 'exceed', label: 'IM Exceed' },
        { value: 'fulfilled', label: 'Fulfilled' },
      ],
      columns: [
        {
          label: 'Role Name',
          field: 'roles_name',
          thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
          tdClass: 'no-wrap color-secondary align-middle',
        },
        {
          label: 'Description',
          field: 'description',
          thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
          tdClass: 'no-wrap color-secondary align-middle',
        },
      ],
      rows: [
        {
          roles_name: 'Super Admin',
          description: 'Super Admin has access to all menu',
        },
        {
          roles_name: 'Admin',
          description: 'Admin has role to make budgeting',
        },
        {
          roles_name: 'User',
          description: 'User has role to view budgeting',
        },
      ],
      rowId: null,
      isRead: false,
      isCreat: false,
      isUpdate: false,
      isDelete: false,
      idDetail: null,
    };
  },

  mounted() {
    this.checkPermission();
    this.getListBoxYear();
    this.getList();
    this.getListAllDepartments();
  },
  methods: {
    async getListAllDepartments() {
      try {
        await this.$store.dispatch('imNumber/GET_LIST_FILTER_DEPARTMENT');
      } catch (error) {
        console.error('Failed to fetch year options:', error);
      }
    },
    showModalFormBRS(id = null) {
      this.rowId = parseInt(id);

      setTimeout(() => {
        this.$bvModal.show('modal-brs');
      }, 200);
    },

    hideModalFormBRS() {
      this.$bvModal.hide('modal-brs');
    },
    showModalFormPK(id = null) {
      this.rowId = parseInt(id);
      setTimeout(() => {
        this.$bvModal.show('modal-pk');
      }, 200);
    },

    hideModalFormPK() {
      this.$bvModal.hide('modal-pk');
    },

    addNew() {
      this.$bvModal.show('modal-1');
      this.isAdd = true;
    },
    selectType(i) {
      this.validateDuplicateType(i);
    },
    selectTypeUpdate(i) {
      this.validateDuplicateTypeUpdate(i);
    },
    validateDuplicateType(i) {
      const listTransactionType = this.memoItems;
      const duplicates_ = this.memoItems.filter((item) => item.type !== '');
      const duplicates = duplicates_.filter(
        (item, index, self) => self.findIndex((obj) => obj.type === item.type && obj.project_name === item.project_name) !== index
      );
      this.duplicateErrorIndexesType = [];
      if (duplicates.length > 0) {
        for (let i = 0; i < listTransactionType.length; i++) {
          if (listTransactionType[i].type === duplicates[0].type) {
            this.duplicateErrorIndexesType.push(i);
          }
        }
      }
    },
    validateDuplicateTypeUpdate(i) {
      const listTransactionType = this.modalUpdate?.im_projects;
      const duplicates_ = this.modalUpdate?.im_projects.filter((item) => item.type !== '');
      const duplicates = duplicates_.filter(
        (item, index, self) => self.findIndex((obj) => obj.type === item.type && obj.project_name === item.project_name) !== index
      );
      this.duplicateErrorIndexesTypeUpdate = [];
      if (duplicates.length > 0) {
        for (let i = 0; i < listTransactionType.length; i++) {
          if (listTransactionType[i].type === duplicates[0].type) {
            this.duplicateErrorIndexesTypeUpdate.push(i);
          }
        }
      }
    },
    isDuplicateErrorType(index) {
      return this.duplicateErrorIndexesType.includes(index);
    },
    isDuplicateErrorTypeUpdate(index) {
      return this.duplicateErrorIndexesTypeUpdate.includes(index);
    },
    removeProject(i) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            this.memoItems.splice(i, 1);
            this.countSum();
            this.$swal('Deleted!', 'Project has been deleted', 'success');
          } catch (e) {
            this.$swal('Error', 'Error while delete data', 'error');
          }
        }
      });
    },
    removeProjectUpdate(i) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            this.modalUpdate.im_projects.splice(i, 1);
            this.countSumUpdate();
            this.$swal('Deleted!', 'Project has been deleted', 'success');
          } catch (e) {
            this.$swal('Error', 'Error while delete data', 'error');
          }
        }
      });
    },
    countSum() {
      this.sumImValue = this.memoItems.reduce((acc, item) => acc + Number(item.relocate_value), 0);
    },
    countSumUpdate() {
      this.sumImValue = this.modalUpdate.im_projects ? this.modalUpdate.im_projects.reduce((acc, item) => acc + Number(item.relocate_value), 0) : 0;
      this.sumImUsedValue = 0;
      if (this.modalUpdate.budget_relocate) {
        for (let i = 0; i < this.modalUpdate?.budget_relocate?.length; i++) {
          this.sumImUsedValue =
            this.sumImUsedValue +
            (this.modalUpdate?.budget_relocate[i]?.budget_actual
              ? this.modalUpdate?.budget_relocate[i]?.budget_actual.reduce((acc, item) => acc + Number(item.po_value), 0)
              : 0);
        }
      }
      this.sumImRemainingValue = this.sumImUsedValue > 0 ? this.sumImValue - this.sumImUsedValue : 0;
    },
    newMemoItems() {
      this.memoItems.push({
        project_name: '',
        type: '',
        relocate_value: 0,
        im_used_value: 0,
        im_remaining_value: 0,
        relocation_status: '',
        fullfilled_status: '',
      });
    },
    newMemoItemsUpdate() {
      this.modalUpdate.im_projects.push({
        id: 0,
        project_name: '',
        type: '',
        relocate_value: 0,
        im_used_value: 0,
        im_remaining_value: 0,
        relocation_status: '',
        fullfilled_status: '',
      });
    },
    async checkPermission() {
      const roleName = localStorage.getItem('roles');
      const roleId = await axiosIns.get('/master-role/find-name?name=' + roleName);
      const menuId = await axiosIns.get('/master-menu/find-link?link=' + this.$route.path);
      const payloadPermission = {
        role_id: roleId.data.data[0]?.id || null,
        menu_id: menuId.data.data[0]?.id || null,
      };
      const checkAuth = await axiosIns.post('/master-role/check-permission', payloadPermission);
      if (checkAuth.data.data?.authorization) {
        this.isRead = checkAuth.data.data?.authorization.includes('read');
        this.isCreat = checkAuth.data.data?.authorization.includes('create');
        this.isUpdate = checkAuth.data.data?.authorization.includes('update');
        this.isDelete = checkAuth.data.data?.authorization.includes('delete');
      }
    },
    truncate(e, field, max, obj) {
      const fullValue = e.target.value;

      this[obj][field] = fullValue;

      if (fullValue.length > max) {
        e.target.value = fullValue.toString().substring(0, max);
      }
    },
    preventInvalidCharacters(e) {
      // Blok karakter 'e', 'E', '-' dan '+'
      if (['e', 'E', '-', '+'].includes(e.key)) {
        e.preventDefault();
      }
    },
    resetModal() {
      this.modalCreate = {
        im_number: '',
        name: '',
        im_category: '',
        im_year: '',
        file: [],
      };
      this.modalUpdate = {
        im_number: '',
        name: '',
        im_category: '',
        im_year: '',
        exist_file: '',
        file: [],
      };
    },
    //action
    updateData(props) {
      if (props.im_category == 'Budget Relocation Statement (BRS)') {
        this.showModalFormBRS(props.id);
        return;
      }
      this.modalCreate = {
        im_number: '',
        name: '',
        im_category: '',
        im_year: '',
        file: [],
      };
      this.modalUpdate = {
        im_number: '',
        name: '',
        im_category: '',
        im_year: '',
        exist_file: '',
        file: [],
        im_projects: [],
      };
      this.showModalFormPK(props.id);
      //this.$bvModal.show('modal-1')
      this.isAdd = false;
      this.modalUpdate.im_number = props.im_number;
      this.modalUpdate.name = props.name;
      this.modalUpdate.im_category = props.im_category;
      this.modalUpdate.im_year = props.im_year.toString();
      this.modalUpdate.exist_file = props.attachments || [];
      this.modalUpdate.im_projects = props.im_projects || [];
      this.modalUpdate.budget_relocate = props.budget_relocate || [];

      this.id = props.id;
      if (this.$refs.fileUpload) {
        this.$refs.fileUpload.value = '';
      }
      this.countSumUpdate();
    },

    getList() {
      this.body.search = this.body.search.trim();
      this.$store.dispatch('imNumber/GET_LIST_DATA', this.body);
    },
    resetForm() {
      this.body = {
        pageNumber: 1,
        pageSize: 10,
        search: '',
        status_actual: '',
        field: '',
        order: '',
        im_category: '',
        im_year: '',
        im_department: '',
        created_at: [],
        updated_at: [],
      };
      this.$store.dispatch('imNumber/GET_LIST_DATA', this.body);
    },
    getListBoxYear() {
      this.$store.dispatch('imNumber/GET_LIST_FILTER_YEAR');
    },
    saveAdd() {
      this.$validator.validateAll().then(async (res) => {
        if (!res) return false;

        try {
          this.isLoading = true;
          //let imProjectsPost =  Object.keys(this.memoItems) || null
          //const arr = Object.keys(obj);
          const formData = new FormData();
          let imProjectPost = [];
          for (let i = 0; i < this.memoItems.length; i++) {
            imProjectPost.push({
              project_name: this.memoItems[i].project_name || null,
              relocate_value: this.memoItems[i].relocate_value || null,
              type: this.memoItems[i].type || null,
            });
          }
          formData.append('name', this.modalCreate.name);
          formData.append('im_number', this.modalCreate.im_number);
          formData.append('im_category', this.modalCreate.im_category);
          formData.append('im_year', this.modalCreate.im_year);
          formData.append('im_projects', JSON.stringify(imProjectPost));

          // Append each selected file
          if (this.modalCreate.file && this.modalCreate.file.length > 0) {
            this.modalCreate.file.forEach((file) => {
              formData.append('files', file);
            });
          }

          this.$store
            .dispatch('imNumber/CREATE_DATA', formData)
            .then((resp) => {
              this.$swal('Saved', 'Your input has been saved', 'success').then(() => {
                this.isLoading = false;
                this.modalCreate = {
                  name: '',
                  im_number: '',
                  im_category: '',
                  im_year: '',
                  file: [],
                };
                this.getList();
                this.$bvModal.hide('modal-1');
                this.memoItems = [];
                this.modalCreate = {
                  im_number: '',
                  name: '',
                  im_category: '',
                  im_year: '',
                  file: [],
                };
              });
            })
            .catch((error) => {
              this.isLoading = false;
              const errorMessage = error.response?.data?.error || 'An error occurred while saving data.';
              this.$swal({
                icon: 'error',
                title: 'Error',
                text: errorMessage,
              });
              console.error('Error:', error);
            });
        } catch (error) {
          const errorMessage = error.response?.data?.error || 'An error occurred while saving data.';
          this.$swal({
            icon: 'error',
            title: 'Error',
            text: errorMessage,
          });
          console.error('Error:', error);
        }
      });
    },

    async saveUpdate() {
      const valid = await this.$validator.validateAll();

      if (!valid) {
        console.log('Form has errors.');
        return;
      }

      let formData = new FormData();
      let imProjectPost = [];
      for (let i = 0; i < this.modalUpdate.im_projects.length; i++) {
        imProjectPost.push({
          id: this.modalUpdate.im_projects[i].id || 0,
          project_name: this.modalUpdate.im_projects[i].project_name || null,
          relocate_value: this.modalUpdate.im_projects[i].relocate_value || null,
          type: this.modalUpdate.im_projects[i].type || null,
        });
      }

      formData.append('name', this.modalUpdate.name);
      formData.append('im_number', this.modalUpdate.im_number);
      formData.append('im_category', this.modalUpdate.im_category);
      formData.append('im_year', this.modalUpdate.im_year);
      formData.append('im_projects', JSON.stringify(imProjectPost));

      // Append each selected file
      if (this.modalUpdate.file && this.modalUpdate.file.length > 0) {
        this.modalUpdate.file.forEach((file) => {
          formData.append('files', file);
        });
      }

      this.isLoading = true;

      this.$store
        .dispatch('imNumber/UPDATE_DATA', { id: this.id, data: formData })
        .then((resp) => {
          this.$swal('Saved', 'Your input has been saved successfully.', 'success').then(() => {
            this.isLoading = false;
            this.modalUpdate = {
              name: '',
              im_number: '',
              im_category: '',
              im_year: '',
              file: [], // Reset file
            };

            this.getList();
            this.$bvModal.hide('modal-1');
            this.modalUpdate = {
              im_number: '',
              name: '',
              im_category: '',
              im_year: '',
              exist_file: '',
              file: [],
              im_projects: [],
            };
          });
        })
        .catch((error) => {
          this.isLoading = false;
          const errorMessage = error.response?.data?.error || 'An error occurred while saving data.';
          this.$swal({
            icon: 'error',
            title: 'Error',
            text: errorMessage,
          });
          console.error('Error:', error);
        });
    },

    deleteData(id, type) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch(type === 'Pengajuan Khusus' ? 'imNumber/DELETE_DATA_PK' : 'imNumber/DELETE_DATA', id)
            .then((resp) => {
              this.getList();
              this.$swal('Deleted!', 'Your file has been deleted', 'success');
            })
            .catch((resp) => {
              this.$swal('Error', 'Error while delete data', 'error');
            });
        }
      });
    },

    async fileUploader(event, type = 'create') {
      const files = event.target.files;
      const validFiles = [];
      const maxSize = 5 * 1024 * 1024; // 5MB in bytes
      const allowedTypes = ['application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];

      // Clear any previous error
      this.fileError = '';

      // Loop through selected files for validation
      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        // Validate file size
        if (file.size > maxSize) {
          this.fileError = 'File size must be less than 5MB.';

          this.$swal.fire({
            title: 'Error',
            text: 'File size must be less than 5MB.',
            icon: 'error',
            confirmButtonText: 'OK',
          });

          this.$refs.fileUpload.value = ''; // Reset file input
          return;
        }

        // Validate file type
        if (!allowedTypes.includes(file.type)) {
          this.fileError = 'Only PDF or DOCX files are allowed.';
          this.$refs.fileUpload.value = ''; // Reset file input

          this.$swal.fire({
            title: 'Error',
            text: 'Only PDF or DOCX files are allowed.',
            icon: 'error',
            confirmButtonText: 'OK',
          });

          return;
        }

        validFiles.push(file);
      }
      // If all files are valid, assign the array of files
      if (type === 'create') {
        this.modalCreate.file = validFiles;
      } else if (type === 'update') {
        this.modalUpdate.file = validFiles;
      }
    },

    // filter
    filterPage() {},
    // filter
    filterPage() {},

    sorting() {},
    sorting() {},

    // Pagination
    onPageChange(payload) {
      this.body.limit = payload.currentPerPage;
      this.body.page = payload.currentPage;
      this.getList();
    },
    onSortChange(params) {
      let sort1 = params[0].field;
      let sort2 = params[0].type;
      this.body.field = sort1;
      if (sort2 == 'none') {
        this.body.order = '';
      } else {
        this.body.order = sort2;
      }
      this.getList();
    },
    showModalDetail(row) {
      console.log('showModalDetail', row.id);
      this.idDetail = row.id;
      setTimeout(() => {
        if (row.im_category == 'Pengajuan Khusus') {
          this.$bvModal.show('modal-detail-pk');
        } else {
          this.$bvModal.show('modal-detail-brs');
        }
      }, 300);
    },
    getRowClass(row) {
      if (row.status_actual === 'fulfilled') {
        return 'success-row';
      } else if (row.status_actual === 'underutilized') {
        return 'warning-row';
      } else if (row.status_actual === 'exceed') {
        return 'danger-row';
      }
    },
  },
};
</script>

<style>
.wrap-text {
  white-space: normal !important;
  word-wrap: break-word !important;
  overflow-wrap: anywhere !important;
  white-space: normal !important;
  word-wrap: break-word !important;
  overflow-wrap: anywhere !important;
}
.card-btn-remove {
  margin-top: -20px;
  margin-left: -15px;
}
.vgt-table tbody tr {
  cursor: pointer !important;
}

.vgt-table tbody tr:hover {
  background-color: #f5f7fa !important;
}
/* Success row border */
.vgt-table tr.success-row {
  border: 2px solid #28a745 !important;
}

/* Warning row border */
.vgt-table tr.warning-row {
  border: 2px solid #ffc107 !important;
}

/* Danger row border */
.vgt-table tr.danger-row {
  border: 2px solid #dc3545 !important;
}

/* Remove default borders if needed */
.vgt-table tr {
  border: none !important;
}
</style>
<style scoped>
.mx-datepicker-range {
  width: 100% !important;
}
</style>
